module.exports = __webpack_public_path__ + "static/media/Moonjae Translated by J_Lee_77777.e1c33454.md";